import {React, observer} from '@api'
import {Button, Spinner} from '@blueprintjs/core'
import {GetApp} from '@material-ui/icons'
import {useStores} from '@modules'
import {} from '@modules/pdf'

const PdfDownloadButton = observer(function PdfDownloadButton() {
  const {pdf: {downloading, downloadPdf, showPDFDownloadButton}} = useStores()

  if (showPDFDownloadButton) {
    return (<Button
      minimal
      icon={downloading ? <Spinner size={20}/> : <GetApp/>}
      // onClick={() => store.isOpen = !store.isOpen} Fn to download the pdf
      onClick={downloadPdf}
      text='Download'
    />)
  }
  return null
})

export default PdfDownloadButton


// WEBPACK FOOTER //
// ./src/modules/pdf/PdfDownloadButton.tsx